import BASE_RULE from '../baseRule';
import {CheckoutType, SearchTypeCheckouts} from './constants';
import {CheckoutsRule} from './types';

export const checkoutsRuleDefaults: CheckoutsRule = {
	...BASE_RULE,
	elementType: SearchTypeCheckouts,
	elementSubType1: CheckoutType.ALL,
	elementSubType2: 0,
	/**
	 * @default all
	 */
	elementValue1: 0,
};

export default checkoutsRuleDefaults;
